<template>
  <el-collapse v-model="activeNames">
    <!-- <el-collapse-item v-if="contractModule === 1" title="基本信息" name="1">
      <info-item :title="['客户名称', '合同编号']" :data="[detail.customerName, detail.contractNo]"></info-item>
      <info-item :title="['合同类型', '关联商机']" :data="[detail.contractTypeName, detail.businessName]"></info-item>
      <info-item :title="['签约形式', '产品线']" :data="[detail.signingFormName, detail.businessLineName]"></info-item>
      <info-item :title="['合同金额(元)', '结算方式']" :data="[detail.contractAmount, detail.settlementName]"></info-item>
      <info-item :title="['回款金额(元)', '开票金额(元)']" :data="[detail.refundAmount, detail.invoiceAmount]"></info-item>
      <info-item :title="['应收金额(元)', '成本(元)']" :data="[detail.receivableAmount, detail.costAmount]"></info-item>
      <info-item :title="['合同开始日期', '合同结束日期']" :data="[detail.startDate, detail.endDate]"></info-item>
      <info-item :title="['备注']" :data="[detail.remarks]"></info-item>
      <info-item :title="['业务员', '业务员所属部门']" :data="[detail.userName, detail.teamName]"></info-item>
    </el-collapse-item> -->
    <el-collapse-item v-if="contractModule === 1" title="基本信息" name="1">
      <info-item
        :title="['客户名称', '合同编号']"
        :data="[detail.customerName, detail.contractNo]"
      ></info-item>
      <info-item
        :title="['合同类型', '关联商机']"
        :data="[detail.contractTypeName, detail.businessName]"
      ></info-item>
      <info-item
        :title="['产品线', '合作模式']"
        :data="[detail.businessLineName, detail.coopModeName]"
      ></info-item>
      <info-item
        :title="['签约形式', '结算方式']"
        :data="[detail.signingFormName, detail.settlementName]"
      ></info-item>
      <info-item
        :title="['合同金额(元)', '回款金额(元)']"
        :data="[detail.contractAmount, detail.refundAmount]"
      ></info-item>
      <info-item
        :title="['应收金额(元)', '开票金额(元)']"
        :data="[detail.receivableAmount, detail.invoiceAmount]"
      ></info-item>
      <info-item
        :title="['成本(元)', '签约日期']"
        :data="[detail.costAmount, detail.signDate]"
      ></info-item>
      <info-item
        :title="['合同开始日期', '合同结束日期']"
        :data="[detail.startDate, detail.endDate]"
      ></info-item>
      <info-item :title="['备注']" :data="[detail.remarks]"></info-item>
      <info-item
        :title="['业务员', '业务员所属部门']"
        :data="[detail.userName, detail.teamName]"
      ></info-item>
    </el-collapse-item>
    <el-collapse-item v-if="contractModule === 2" title="基本信息" name="1">
      <info-item :title="['客户名称']" :data="[detail.customerName]"></info-item>
      <info-item
        :title="['合同编号', '合同类型']"
        :data="[detail.contractNo, detail.contractTypeName]"
      ></info-item>
      <info-item
        :title="['签订日期', '合作科室']"
        :data="[detail.signDate, detail.departmentNames.join('，')]"
      ></info-item>
      <info-item
        :title="['合同金额(元)', '开票金额(元)']"
        :data="[detail.contractAmount, detail.invoiceAmount]"
      ></info-item>
      <info-item
        :title="['回款金额(元)', '应收金额(元)']"
        :data="[detail.refundAmount, detail.receivableAmount]"
      ></info-item>
      <info-item
        :title="['合同开始日期', '合同结束日期']"
        :data="[detail.startDate, detail.endDate]"
      ></info-item>
      <info-item :title="['备注']" :data="[detail.remarks]"></info-item>
      <info-item
        :title="['业务员', '业务员所属部门']"
        :data="[detail.userName, detail.teamName]"
      ></info-item>
    </el-collapse-item>
    <el-collapse-item v-if="contractModule === 3" title="基本信息" name="1">
      <info-item
        :title="['客户名称', '合同编号']"
        :data="[detail.customerName, detail.contractNo]"
      ></info-item>
      <info-item
        :title="['合同类型', '签订日期']"
        :data="[detail.contractTypeName, detail.signDate]"
      ></info-item>
      <info-item
        :title="['合作科室', '科室综合收入比例']"
        :data="[detail.departmentNames.join('，'), `${detail.incomeRatio}%`]"
      ></info-item>
      <info-item
        :title="['合同金额(元)', '开票金额(元)']"
        :data="[detail.contractAmount, detail.invoiceAmount]"
      ></info-item>
      <info-item
        :title="['回款金额(元)', '应收金额(元)']"
        :data="[detail.refundAmount, detail.receivableAmount]"
      ></info-item>
      <info-item
        :title="['岗前培训费(元)', '驻点带教费(元)']"
        :data="[detail.preJobTraining, detail.residentTeach]"
      ></info-item>
      <info-item
        :title="['定期带教费(元)', '多点执业费(元)']"
        :data="[detail.regularTeach, detail.multipointPractice]"
      ></info-item>
      <info-item
        :title="['运营启动费(元)', '运营运维费(元)']"
        :data="[detail.operateStarted, detail.operateOperation]"
      ></info-item>
      <info-item
        :title="['合同开始日期', '合同结束日期']"
        :data="[detail.startDate, detail.endDate]"
      ></info-item>
      <info-item :title="['备注']" :data="[detail.remarks]"></info-item>
      <info-item
        :title="['业务员', '业务员所属部门']"
        :data="[detail.userName, detail.teamName]"
      ></info-item>
    </el-collapse-item>
    <el-collapse-item title="系统信息" name="2">
      <info-item
        :title="['创建人', '创建时间']"
        :data="[detail.createdName, detail.gmtCreatedStr]"
      ></info-item>
      <info-item
        :title="['最后修改人', '最后修改时间']"
        :data="[detail.modifierName, detail.gmtModifiedStr]"
      ></info-item>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import InfoItem from "@/components/base/detail-info-item.vue";

export default {
  props: {
    detail: Object,
    contractModule: Number,
  },
  components: {
    InfoItem,
  },
  data() {
    return {
      activeNames: ["1", "2"],
    };
  },
};
</script>

<style lang="less">
@import "~@/styles/common.less";

.panel-item {
  padding: 0 10px;
  label {
    width: 150px;
    display: inline-block;
    color: @color--info;
  }
  &:last-child {
    .el-col {
      border: none;
    }
  }
}
</style>
